import { TextArea } from '@/components/commons/forms/TextArea.component'
import { Title } from '@/components/commons/typography/Title'
import { helperTextStyle } from '@/components/pages/profile_v2/profileBar/styles/profilePersonalInfo.css'
import { cssClass } from '@/shared/utils'
import { useHighlightEditorStore } from 'containers/highlights/store/highlightEditor'
import { ChangeEvent, useState } from 'react'

const MAX_CHAR_COUNT = 500

export const HAbout = () => {
  const { highlight, updateHighlight } = useHighlightEditorStore()
  const [charCount, setCharCount] = useState(
    highlight?.about ? highlight.about.length : 0
  )

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const inputText = e.target.value
    const remainingChars = MAX_CHAR_COUNT - inputText.length

    if (remainingChars >= 0) {
      setCharCount(inputText.length)
      updateHighlight({ about: inputText })
    }
  }

  const remainingCharCount = MAX_CHAR_COUNT - (highlight?.about || '').length

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Title as="label" variation="xSmall">
        About This Highlight
      </Title>
      <TextArea
        className={['bg-white-primary']}
        value={highlight?.about || ''}
        onChange={handleChange}
        usePlaceholder={true}
        placeholder="Want people to know about your unique approach to achieving brand and campaign objectives? Tell them about it here..."
      />
      <p className={cssClass([helperTextStyle, 'mb-12 text-right'])}>
        {remainingCharCount} characters remaining
      </p>
    </div>
  )
}
